import listQuery from '../../../graphql/queries/supplier/SupplierContactListQuery.graphql';
import fragment from '../../../graphql/fragments/supplier/SupplierContactFragment.graphql';
import defaultQuery from '../../../graphql/queries/supplier/SupplierContactDefault.graphql';
import { EntityType } from '../../../@types/entityTypes';
import { Direction } from '../../schema/p4types';

const SupplierContact: EntityType = {
  type: 'SupplierContact',
  title: 'Supplier Contacts',
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name.fullName',
    customVariables: () => {
      return {
        orderBy: 'name',
        orderDirection: Direction.Asc,
        first: 200,
      };
    },
  },
  fragment,
  default: defaultQuery,
  screenReference: 'SUPPLIER_CONTACT',
};

export default SupplierContact;
